import moment from 'moment-timezone';
import {
  getPolicyValue, getPremiumPeriodValue, getFrequencyIntlId,
  getPolicyBeneficialDisplay, getPolicyLifeInsuredDisplay, isTaxDeductiblePolicy,
  isPolicyCategory, isPolicySubCategory, getRoomClass, isILASPolicy,
  isAnnuityPolicy, isPolicyInsurer, isRiderPolicy,
  isInsuredNotMePolicy, isPaidUpPolicy, isDraftPolicy
} from '../../../utils/policy';
import { formatNumber } from '../../../utils/formatNumber';
import { subCategoryDeatils } from './constants';

export const createTransformPolicyData = ({
  intl,
  currency,
  isCompanyCategory,
  selectShowLacks,
  selectTotalWithdrawals,
  selectCurrencyPerYear
}) => {
  return (category) => {
    if (!category?.subCategories) return [];
    let policies = category.subCategories.flatMap(sc => sc.policies || []);

    let totalLifeCoverage = 0;
    let totalCICoverage = 0;
    let totalYearlyPremium = 0;
    let totalMarketValue = 0;
    let previousSubCategoryId = null;

    let newPolicies = policies.map(policy => {
      const isLifePolicy = isPolicySubCategory(policy, 'life');
      const isCIPolicy = isPolicySubCategory(policy, 'ci');
      const isMedicalPolicy = isPolicySubCategory(policy, 'medical');
      const isAccidentPolicy = isPolicySubCategory(policy, 'accident');
      const lifeCoverageValue = getPolicyValue(policy, 'lifeCoverage', currency);
      const ciCoverageValue = getPolicyValue(policy, 'sumInsured', currency);
      const isDummy = Boolean(policy.dummy);
      const dummyProtectionLackEntry = isDummy && !isILASPolicy(policy) && !isAnnuityPolicy(policy);
      const marketValueValue = getPolicyValue(policy, 'marketValue', currency);
      const totalWithdrawnValue = getPolicyValue(policy, 'totalWithdrawn', currency);
      const isDummyExplicitNonTaxDeductible = Boolean(policy.explicitNonTaxDeductible);
      const isTaxDeductibleRelated =
        isPolicySubCategory(policy, 'provident') ||
        isAnnuityPolicy(policy) ||
        (isPolicyCategory(policy, 'personal') && isPolicySubCategory(policy, 'medical'));
      const isInsuredNotMe = isInsuredNotMePolicy(policy);
      const isPaidUp = isPaidUpPolicy(policy);
      const yearlyPremium = getPremiumPeriodValue(policy, 'Yearly', currency);
      const marketValue = getPolicyValue(policy, 'marketValue', currency);

      if (!isAccidentPolicy && !isInsuredNotMe) {
        totalLifeCoverage += getPolicyValue(policy, 'lifeCoverage', currency);
      }

      if (isCIPolicy && !isInsuredNotMe) {
        totalCICoverage += getPolicyValue(policy, 'sumInsured', currency);
      }

      if (!isPaidUp) {
        totalYearlyPremium += yearlyPremium;
      }

      totalMarketValue += marketValue;

      let isFirst = false;
      if (policy.subCategoryId !== previousSubCategoryId) {
        isFirst = true;
        previousSubCategoryId = policy.subCategoryId;
      }

      return {
        _id: policy._id,
        subCategoryId: policy.subCategoryId || '',
        subCategory: policy.subCategoryId ? intl.formatMessage({ id: subCategoryDeatils[policy.subCategoryId] }) : '',
        insurer: policy.insurer
          ? isPolicyInsurer(policy, 'other')
            ? policy.insurer
            : intl.formatMessage({ id: policy.insurer })
          : '',
        policyName: (isCompanyCategory ? policy.companyName : policy.policyName) || '',
        policyNumber: policy.policyNumber || '',
        saving:
          !isDummy && (isPolicySubCategory(policy, 'saving') || policy.feature === 'Saving')
            ? intl.formatMessage({ id: 'y' })
            : policy.feature === 'Non Saving'
              ? intl.formatMessage({ id: 'n' })
              : '',
        policyStartDate: policy.policyStartDate ? moment(policy.policyStartDate).format('YYYY-MM-DD') : '',
        protectionTerms: policy.protectionTerms ? policy.protectionTerms.includes("Till age") ? intl.formatMessage({ id: "until-age" }, { age: policy.protectionTerms.replace("Till age ", "") }) : policy.protectionTerms.replace(/Years|Whole Life|Other/gi, match => intl.formatMessage({ id: match })) : '',
        paymentTerms: policy.paymentTerms ? policy.paymentTerms.includes("Till age") ? intl.formatMessage({ id: "until-age" }, { age: policy.paymentTerms.replace("Till age ", "") }) : policy.paymentTerms.replace(/Years|Whole Life|Other/gi, match => intl.formatMessage({ id: match })) : '',
        policyStatus: policy.selectedPolicyStatus ? policy.selectedPolicyStatus === 'pr-lacks' ? 'lack' : intl.formatMessage({ id: policy.selectedPolicyStatus.toLowerCase() }) : '',
        beneficial: policy.beneficial,
        lifeInsured: policy.lifeInsured,
        lifeInsuredSelected: getPolicyLifeInsuredDisplay(policy, intl) || '',
        beneficialSelected: getPolicyBeneficialDisplay(policy, intl) || '',
        remark: policy.remark || '',
        lifeCoverage: isAccidentPolicy
          ? '-'
          : lifeCoverageValue
            ? formatNumber(lifeCoverageValue, intl)
            : isLifePolicy && selectShowLacks
              ? 'lack'
              : '-',
        ciCoverage: isCIPolicy
          ? ciCoverageValue
            ? formatNumber(ciCoverageValue, intl)
            : selectShowLacks
              ? 'lack'
              : '-'
          : '-',
        multiClaim: isCIPolicy
          ? policy.multiClaim
            ? intl.formatMessage({ id: 'y' })
            : selectShowLacks
              ? 'lack'
              : '-'
          : '-',
        roomClass: isMedicalPolicy
          ? getRoomClass(policy)
            ? intl.formatMessage({ id: getRoomClass(policy) })
            : selectShowLacks
              ? 'lack'
              : '-'
          : '-',
        coverageType: isMedicalPolicy
          ? policy.coverageType
            ? intl.formatMessage({ id: policy.coverageType })
            : selectShowLacks
              ? 'lack'
              : '-'
          : '-',
        accidentCoverage: isAccidentPolicy
          ? lifeCoverageValue
            ? formatNumber(lifeCoverageValue, intl)
            : selectShowLacks
              ? 'lack'
              : '-'
          : '-',
        compensation: dummyProtectionLackEntry
          ? selectShowLacks
            ? 'lack'
            : ''
          : lifeCoverageValue
            ? formatNumber(lifeCoverageValue, intl)
            : '',
        guaranteeValue: dummyProtectionLackEntry
          ? ''
          : isILASPolicy(policy)
            ? isDummy
              ? ''
              : intl.formatMessage({ id: 'y' })
            : selectShowLacks && isDummy && subCategoryDeatils[policy.subCategoryId] !== "Provident Fund"
              ? 'lack'
              : '',
        isAnnuity: dummyProtectionLackEntry
          ? ''
          : isAnnuityPolicy(policy)
            ? isDummy
              ? ''
              : intl.formatMessage({ id: 'y' })
            : selectShowLacks && isDummy && subCategoryDeatils[policy.subCategoryId] !== "Provident Fund"
              ? 'lack'
              : '',
        marketValue: marketValueValue ? formatNumber(marketValueValue, intl) : '',
        totalWithdrawn:
          Boolean(totalWithdrawnValue) && selectTotalWithdrawals ? formatNumber(totalWithdrawnValue, intl) : '',
        taxDeductible: isDummy
          ? isDummyExplicitNonTaxDeductible
            ? 'notTaxDeductible'
            : ''
          : isTaxDeductiblePolicy(policy)
            ? 'taxDeductible'
            : isTaxDeductibleRelated
              ? 'notTaxDeductible'
              : '',
        currency: policy.currency,
        currencyTranslation: policy.currency ? intl.formatMessage({ id: policy.currency }) : '',
        lumpSumAmount: policy.lumpSumAmount ? formatNumber(policy.lumpSumAmount, intl) : '',
        premium: policy.premium ? formatNumber(policy.premium, intl) : '',
        frequency: policy.frequency,
        frequencyTranslation: policy.premium && getFrequencyIntlId(policy) ? intl.formatMessage({ id: getFrequencyIntlId(policy) }) : '',
        premiumPerYear: yearlyPremium ? formatNumber(yearlyPremium, intl) : '',
        isRider: isRiderPolicy(policy),
        isInsuredNotMe: isInsuredNotMe,
        isNotLevelPremium: policy.levelPremium === 'No',
        isPaidUp: isPaidUp,
        isTotalRow: false,
        isDraft: isDraftPolicy(policy),
        isDummy,
        isFirst
      };
    });

    if (newPolicies.length === 0) {
      newPolicies.push({ _id: null });
    } else {
      let lifeTotalCoverage = `${totalLifeCoverage === 0 ? selectShowLacks ? '0&nbsp;lack' : '0' : formatNumber(totalLifeCoverage, intl)}`;
      let ciTotalCoverage = `${totalCICoverage === 0 ? selectShowLacks ? '0&nbsp;lack' : '0' : formatNumber(totalCICoverage, intl)}`;
      newPolicies.push({
        _id: 'total',
        subCategoryId: 'total',
        subCategory: intl.formatMessage({ id: "total-amount" }),
        multiClaim: `${intl.formatMessage({ id: 'pr-table-life-protection-sum' })}: ${intl.formatMessage({ id: currency })}${lifeTotalCoverage}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;${intl.formatMessage({ id: 'pr-table-ci-protection-sum' })}: ${intl.formatMessage({ id: currency })}${ciTotalCoverage}`,
        generalCoverage: `<div><div style="display: flex; align-items: center">lifeTotal${lifeTotalCoverage}</div><div style="display: flex; align-items: center; margin-top: 8px">ciTotal${ciTotalCoverage}</div></div>`,
        protectionDetails: totalMarketValue === 0 ? '' : formatNumber(totalMarketValue, intl),
        isAnnuity: totalMarketValue === 0 ? '' : `${intl.formatMessage({ id: 'pr-table-market-value-sum' })}: ${intl.formatMessage({ id: currency })} ${formatNumber(totalMarketValue, intl)}`,
        frequencyTranslation: (totalYearlyPremium === 0 || !selectCurrencyPerYear) ? '' :
          intl.formatMessage(
            { id: 'amount-per-year-and-month' },
            {
              amountText: `${intl.formatMessage({ id: currency })} ${formatNumber(totalYearlyPremium, intl)}`,
              monthlyAmount: formatNumber(Math.round(totalYearlyPremium / 12), intl)
            }
          ),
        isTotalRow: true,
        isFirst: false
      });
    }

    return newPolicies;
  };
};